
import Logo from '../assets/static/logo.png'
import Logo2 from '../assets/static/logo2.png'
import NoData from '../assets/static/no-data.png'
import Blank from '../assets/static/blank.jpg'
import fourOfour from '../assets/static/404.png'

export const Images = {
    Logo,
    Logo2,
    NoData,
    Blank,
    fourOfour
} 
